import { useMemo } from "react";
import { getCurrentUser } from "../reducers/authSlice";
import { useAppSelector } from "./store";
import { User } from "../types/User";

function useAuth() {
  const user = useAppSelector(getCurrentUser) as User;

  return useMemo(() => user, [user]);
}

export default useAuth;
